import React from "react";
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import './Map.css'

export default function SimpleMap(props) {
    const defaultProps = {
        center: { lat: props.lat, lng: props.lng },
        zoom: 10
    };

    function Markers(props) {
        return (
            <>
                {
                    props.otherMarkers &&
                        props.otherMarkers.map((marker, index) => (
                            <Marker
                                key={index}
                                lat={marker.lat}
                                lng={marker.lng}
                                markerId={marker.markerId}
                                className={"MapMarker"}
                            />
                        ))
                }
            </>
        )
    }

    return (
        // Important! Always set the container height explicitly
        <div style={{ height: '300px', width: '100%' }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: "AIzaSyAG0cNYGOXO8qMF55jRowfgwk1GDagvgRY" }}
                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
            >
                <Marker
                    lat={props.lat}
                    lng={props.lng}
                    markerId={"Shipping container location"}
                    className={"MapMarker"}
                    // draggable={true}
                    // onDragStart={(e, { latLng }) => {}}
                    // onDrag={(e, { latLng }) => {}}
                    // onDragEnd={(e, { latLng }) => {}}
                />
            </GoogleMapReact>
        </div>
    );
}